import React, { useMemo } from 'react';
import { Tag } from 'antd';
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  CopyOutlined,
  ExclamationCircleOutlined,
  InteractionOutlined,
} from '@ant-design/icons';
import type { IInvoiceStatusTagProps } from './types';

export const InvoiceStatusTag: React.FC<IInvoiceStatusTagProps> = (props) => {
  const { status, partiallyPaidAmount } = props;

  const getTagProps = (): { color: string; icon: React.ReactNode } | object => {
    switch (status) {
      case 'need_action':
        return { color: 'gold', icon: <InteractionOutlined /> };
      case 'waiting_original':
        return { color: 'gold', icon: <CopyOutlined /> };
      case 'original_sent':
        return { color: 'gold', icon: <CopyOutlined /> };
      case 'waiting':
        return { color: '', icon: <ClockCircleOutlined /> };
      case 'partially_paid':
        return { color: partiallyPaidAmount === 0 ? 'red' : 'green', icon: <ClockCircleOutlined /> };
      case 'completed':
        return { color: 'green', icon: <CheckCircleOutlined /> };
      case 'problem':
        return { color: 'orange', icon: <ExclamationCircleOutlined /> };
      case 'loss':
        return { color: '', icon: <CloseCircleOutlined /> };
      case 'legal_actions':
        return { color: 'red', icon: <ExclamationCircleOutlined /> };
      default:
        return {};
    }
  };

  const tagProps = useMemo(getTagProps, [partiallyPaidAmount, status]);

  if (!status) return null;

  return <Tag {...tagProps}>{status}</Tag>;
};
